module.exports = __webpack_public_path__ + "img/arw-more-white.f622691d.svg";